import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1FinancialModel extends ModelBase<ReservationType1FinancialModel, ReservationType1FinancialDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationId: string = "";

    @observable
    public agreedPrice: string = "";

    @observable
    public agreedPriceWords: string = "";

    @observable
    public showDeposit: boolean = true;

    @observable
    public amountDeposit: string = "";

    @observable
    public percentageDeposit: number | undefined = 0;

    @observable
    public specialConditions: string = "";

    @observable
    public paymentCash: boolean = false;

    @observable
    public paymentCheque: boolean = false;

    @observable
    public paymentDebit: boolean = false;

    @observable
    public paymentCreditCard: boolean = false;

    @observable
    public paymentBankTransfer: boolean = false;

    @observable
    public communicationPost: boolean = false;

    @observable
    public communicationTelephone: boolean = false;

    @observable
    public communicationEmail: boolean = false;

    @observable
    public marketingFromUs: boolean = false;

    @observable
    public marketingFromSuppliers: boolean = false;

    @observable
    public receivedLABCWarranty: boolean = false;

    @observable
    public receivedCustomerCode: boolean = false;

    @observable
    public isSectionComplete: boolean = false;

    @observable
    public completedDate: string = "";

    @observable
    public completedIdentityUserId: string = "";

    @observable
    public legalCopy: string = "";

    @observable
    public depositDueAt: string | undefined = undefined;

    @observable
    public purchaserOneSignatureUrl: string = "";

    @observable
    public purchaserOneSignatureDataUrl: string = "";

    @observable
    public purchaserOneSignatureDate = new Date().toString();

    @observable
    public purchaserTwoSignatureUrl: string = "";

    @observable
    public purchaserTwoSignatureDataUrl: string = "";

    @observable
    public purchaserTwoSignatureDate = new Date().toString();

    @observable
    public salesAgentSignatureUrl: string = "";

    @observable
    public salesAgentSignatureDataUrl: string = "";

    @observable
    public salesAgentSignatureDate = new Date().toString();

    @observable
    public companyStructuralWarrantyProviderId: string | undefined = undefined;

    @observable
    public percentageOwned: number | undefined = 0;

    @observable
    public incentive: string | undefined = undefined;

    @observable
    public otherIncentive: string = "";

    @observable
    public amount: string | undefined = undefined;

    @observable
    public salesAgentPosition: string = "";

    //reservation v2 specific flags

    @observable
    public readReservationAgreement: boolean = false;

    @observable
    public readSummaryChecklist: boolean = false;

    @observable
    public confirmedNHQBCP: boolean = false;
    //#endregion roperties

    @action
    public fromDto = (reservationDto: ReservationType1FinancialDTO) => {
        this.id = reservationDto.id;
        this.reservationId = reservationDto.reservationId;
        this.agreedPrice = reservationDto.agreedPrice;
        this.agreedPriceWords = reservationDto.agreedPriceWords;
        this.showDeposit = reservationDto.showDeposit;
        this.percentageDeposit = reservationDto.percentageDeposit;
        this.amountDeposit = reservationDto.amountDeposit;
        this.specialConditions = reservationDto.specialConditions;
        this.paymentCash = reservationDto.paymentCash;
        this.paymentCheque = reservationDto.paymentCheque;
        this.paymentDebit = reservationDto.paymentDebit;
        this.paymentCreditCard = reservationDto.paymentCreditCard;
        this.paymentBankTransfer = reservationDto.paymentBankTransfer;
        this.communicationPost = reservationDto.communicationPost;
        this.communicationTelephone = reservationDto.communicationTelephone;
        this.communicationPost = reservationDto.communicationPost;
        this.communicationEmail = reservationDto.communicationEmail;
        this.marketingFromUs = reservationDto.marketingFromUs;
        this.marketingFromSuppliers = reservationDto.marketingFromSuppliers;
        this.receivedLABCWarranty = reservationDto.receivedLABCWarranty;
        this.receivedCustomerCode = reservationDto.receivedCustomerCode;
        this.isSectionComplete = reservationDto.isSectionComplete;
        this.completedDate = reservationDto.completedDate;
        this.completedIdentityUserId = reservationDto.completedIdentityUserId;
        this.depositDueAt = reservationDto.depositDueAt;
        this.purchaserOneSignatureUrl = reservationDto.purchaserOneSignatureUrl;
        this.purchaserOneSignatureDataUrl = reservationDto.purchaserOneSignatureDataUrl;
        this.purchaserOneSignatureDate = reservationDto.purchaserOneSignatureDate || new Date().toString();
        this.purchaserTwoSignatureUrl = reservationDto.purchaserTwoSignatureUrl;
        this.purchaserTwoSignatureDataUrl = reservationDto.purchaserTwoSignatureDataUrl;
        this.purchaserTwoSignatureDate = reservationDto.purchaserTwoSignatureDate || new Date().toString();
        this.salesAgentSignatureUrl = reservationDto.salesAgentSignatureUrl;
        this.salesAgentSignatureDataUrl = reservationDto.salesAgentSignatureDataUrl;
        this.salesAgentSignatureDate = reservationDto.salesAgentSignatureDate || new Date().toString();
        this.companyStructuralWarrantyProviderId = reservationDto.companyStructuralWarrantyProviderId;
        this.percentageOwned = reservationDto.percentageOwned;
        this.incentive = reservationDto.incentive;
        this.otherIncentive = reservationDto.otherIncentive;
        this.amount = reservationDto.amount;
        this.salesAgentPosition = reservationDto.salesAgentPosition;

        //reservation v2 specific flags

        this.readReservationAgreement = reservationDto.readReservationAgreement;
        this.readSummaryChecklist = reservationDto.readSummaryChecklist;
        this.confirmedNHQBCP = reservationDto.confirmedNHQBCP;
    };

    public toDto = (): ReservationType1FinancialDTO => {
        return {
            id: this.id,
            reservationId: this.reservationId,
            agreedPrice: this.agreedPrice,
            agreedPriceWords: this.agreedPriceWords,
            amountDeposit: this.amountDeposit,
            showDeposit: this.showDeposit,
            percentageDeposit: this.percentageDeposit,
            specialConditions: this.specialConditions,
            paymentCash: this.paymentCash,
            paymentCheque: this.paymentCheque,
            paymentDebit: this.paymentDebit,
            paymentCreditCard: this.paymentCreditCard,
            paymentBankTransfer: this.paymentBankTransfer,
            communicationPost: this.communicationPost,
            communicationTelephone: this.communicationTelephone,
            communicationEmail: this.communicationEmail,
            marketingFromUs: this.marketingFromUs,
            marketingFromSuppliers: this.marketingFromSuppliers,
            receivedLABCWarranty: this.receivedLABCWarranty,
            receivedCustomerCode: this.receivedCustomerCode,
            isSectionComplete: this.isSectionComplete,
            completedDate: this.completedDate,
            completedIdentityUserId: this.completedIdentityUserId,
            depositDueAt: this.depositDueAt,
            purchaserOneSignatureUrl: this.purchaserOneSignatureUrl,
            purchaserOneSignatureDataUrl: this.purchaserOneSignatureDataUrl,
            purchaserOneSignatureDate: this.purchaserOneSignatureDate,
            purchaserTwoSignatureUrl: this.purchaserTwoSignatureUrl,
            purchaserTwoSignatureDataUrl: this.purchaserTwoSignatureDataUrl,
            purchaserTwoSignatureDate: this.purchaserTwoSignatureDate,
            salesAgentSignatureUrl: this.salesAgentSignatureUrl,
            salesAgentSignatureDataUrl: this.salesAgentSignatureDataUrl,
            salesAgentSignatureDate: this.salesAgentSignatureDate,
            companyStructuralWarrantyProviderId: this.companyStructuralWarrantyProviderId,
            percentageOwned: this.percentageOwned,
            incentive: this.incentive,
            otherIncentive: this.otherIncentive,
            amount: this.amount,

            //Reservation v2 specific flags
            readReservationAgreement: this.readReservationAgreement,
            readSummaryChecklist: this.readSummaryChecklist,
            confirmedNHQBCP: this.confirmedNHQBCP,
            salesAgentPosition: this.salesAgentPosition,
        };
    };
}

export interface ReservationType1FinancialDTO {
    id: string | undefined;
    reservationId: string;
    agreedPrice: string;
    agreedPriceWords: string;
    showDeposit: boolean;
    percentageDeposit: number | undefined;
    amountDeposit: string;
    specialConditions: string;
    paymentCash: boolean;
    paymentCheque: boolean;
    paymentDebit: boolean;
    paymentCreditCard: boolean;
    paymentBankTransfer: boolean;
    communicationPost: boolean;
    communicationTelephone: boolean;
    communicationEmail: boolean;
    marketingFromUs: boolean;
    marketingFromSuppliers: boolean;
    receivedLABCWarranty: boolean;
    receivedCustomerCode: boolean;
    depositDueAt: string | undefined;
    purchaserOneSignatureUrl: string;
    purchaserOneSignatureDataUrl: string;
    purchaserOneSignatureDate: string;
    purchaserTwoSignatureUrl: string;
    purchaserTwoSignatureDataUrl: string;
    purchaserTwoSignatureDate: string;
    salesAgentSignatureUrl: string;
    salesAgentSignatureDataUrl: string;
    salesAgentSignatureDate: string;
    isSectionComplete: boolean;
    completedDate: string;
    completedIdentityUserId: string;
    companyStructuralWarrantyProviderId: string | undefined;
    percentageOwned: number | undefined;
    incentive: string | undefined;
    otherIncentive: string;
    amount: string | undefined;
    salesAgentPosition: string;
    //Reservation v2 specific flags
    readReservationAgreement: boolean;
    readSummaryChecklist: boolean;
    confirmedNHQBCP: boolean;
}
